import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        mainContainer: {
            mt: 2,
            width: '100%',
        },
        selectContainer: {
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
            mt: 2,
            width: '100%',
            maxHeight: '500px',
            overflow: 'auto',
            paddingTop: 1,
        },
        impar: {
            [breakpoints.up(1350)]: {
                width: '49%',
            },
            [breakpoints.down(1350)]: {
                width: '100%',
            }

        },
        par: {
            [breakpoints.up(1350)]: {
                width: '45%',
            },
            [breakpoints.down(1350)]: {
                width: '100%',
            }
        },
        containerButtons: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
        }
    }
}